// Get the entries from a record while preserving the original types
export function typedEntries<K extends PropertyKey, V>(obj: Record<K, V>): [K, V][];
export function typedEntries<K extends PropertyKey, V>(obj: Partial<Record<K, V>>): [K, NonNullable<V>][];
export function typedEntries<K extends PropertyKey, V>(
  obj: Record<K, V> | Partial<Record<K, V>>,
): [K, V][] | [K, NonNullable<V>][] {
  // Object.entries removes the key type and we cannot get it back
  // so the solution is to use TS generics to get the key and cast it back explicitly
  // For Partial types, we filter out undefined values since Object.groupBy may create undefined values
  const entries = Object.entries(obj).filter(([, value]) => value !== undefined);
  return entries as [K, NonNullable<V>][];
}

export function typedFromEntries<K extends PropertyKey, V>(entries: [K, V][]): Record<K, V> {
  return Object.fromEntries(entries) as Record<K, V>;
}
